import { render, staticRenderFns } from "./ICD10.vue?vue&type=template&id=59343df8&scoped=true"
import script from "./ICD10.vue?vue&type=script&lang=js"
export * from "./ICD10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59343df8",
  null
  
)

export default component.exports